import React from 'react'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'

export const ConsultaRemessaPagamentoList = (props) => <DefaultDataTable data={props} />
